import { gql } from "@apollo/client";
export const FindUncompletedClientTransactions = gql `
  query FindUncompletedClientTransactions(
    $input: FindUncompletedClientTransactionsInput!
  ) {
    FindUncompletedClientTransactions(input: $input) {
      _id
      amount
      company {
        _id
        name
      }
      dueDate
      external {
        _id
        name
      }
      transactionIdentifier
      sourceBankAccount {
        currency
      }
      destinationBankAccount {
        currency
      }
    }
  }
`;
